// extracted by mini-css-extract-plugin
module.exports = {"page":"PageLayout_page__ZK1LS","content":"PageLayout_content__trluJ","navbar":"PageLayout_navbar__hzvpj"};